import React from 'react'
import { Route, IndexRedirect } from 'react-router'
import App from './components/App'

import { 
  Players, 
  Player, 
  Bets,
  Tickets,
  TicketPage,
  Recommendations,
  Coupons,
  Recommender,
  PlayerAnalytics
} from './components/Players'
import { Projects, Project } from './components/Projects'

import { Boosting } from './components/Boosting'

import { Login } from './components/Auth'
import { withAuthentication } from './decorators'

export default <Route path="/" component={App}>
  <IndexRedirect to="players" />

  <Route path="players" component={withAuthentication(Players)} />
  
  <Route path="players/:playerId" component={withAuthentication(Player)} >
    <Route path="analytics" component={PlayerAnalytics} />
    <Route path="bets" component={Bets} />
    <Route path="tickets" component={Tickets} />    
    <Route path="tickets/:ticketId" component={TicketPage} />
    <Route path="recommendations" component={Recommendations} />
    <Route path="coupons" component={Coupons} />
    <Route path="recommender" component={Recommender} />
  </Route>

	<Route path="projects" component={withAuthentication(Projects)} />
	<Route path="projects/:modelId/settings" component={withAuthentication(Project)} />
  <Route path="boosting" component={withAuthentication(Boosting)} />

  <Route path="login" component={Login} />
</Route>



// WEBPACK FOOTER //
// ./src/routes.js